module.exports = __webpack_public_path__ + "static/media/english.2248ca9b.svg";